import CONSTANTS from "../../assets/js/Constants"
import moment from "moment"

const events = []
const convertEventsDefault = (events) => {
   // Chị Thơm trả cho em thêm 1 param [type_document]="1"
   // 1.Đăng ký xe 2.Phù hiệu 3.Đăng kiểm 4.Bảo hiểm
   let result = []
   for (let item of events) {
      result.push({
         id_hoso: item.vehicle_renewal_setting_id,
         start: moment(item.expired_date).toDate(),
         end: moment(item.expired_date).toDate(),
         id_issue: item.id_issue,
         title: item.name,
         factory_id: item.factory_id,
         vehicle_id: item.vehicle_id,
         plate: item.plate,
         type: item.type_issue,
         type_document: item.vehicle_renewal_type_id,
         // apiView:
         //    item.type_issue === "1"
         //       ? `maintanance_calendar_v3_config/${item.vehicle_id}/${item.plate}`
         //       : item.type_issue === "2"
         //       ? `maintanance_calendar_config/${item.factory_id}/${item.vehicle_id}/${item.plate}`
         //       : undefined,
         description: item.name,
         options: null
      })
   }
   return result
}

export default function (state = events, { type, payload }) {
   switch (type) {
      case CONSTANTS.ACTION.CALENDAR.SET_ALL_CALENDAR_BY_TIME:
         return [...convertEventsDefault(payload)]

      default:
         return [...state]
   }
}
